import { render, staticRenderFns } from "./box_5.vue?vue&type=template&id=1e32379a&scoped=true"
import script from "./box_5.vue?vue&type=script&lang=js"
export * from "./box_5.vue?vue&type=script&lang=js"
import style0 from "./box_5.vue?vue&type=style&index=0&id=1e32379a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32379a",
  null
  
)

export default component.exports